var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FormButton"},[_c('a',{attrs:{"href":_vm.link}},[_c('div',{staticClass:"form_btn"},[_c('p',[_vm._v(_vm._s(_vm.ButtonText))]),_c('img',{attrs:{"src":_vm.rt+'/img/lp/more_btn_mark_wt.png',"alt":"矢印アイコン"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }